// Shared styled components for initiate-proposal carrier pages.
// Import only what each carrier needs; carrier-specific styles live in their own folders.

import { Alert, colors, IMForm, IMSelect } from '@insurancemenu/imenu-components-lib';
import {
  IMZipCodeField,
  IMZipCountyField,
  IMZipStateField,
} from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/zip';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import SectionTitle from 'components/common/general/SectionTitle';
import styled, { css } from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  max-width: none;
  width: 100%;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  box-sizing: border-box;
  padding: 4rem 10rem 8rem;
  margin: 0;
  min-height: 40rem;

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
  }
`;

export const TabIMFormStyled = styled(IMForm)`
  max-width: none;
  width: 100%;
  padding: 0;
  margin-bottom: 4rem;
`;

export const FollowingSectionTitleStyled = styled(SectionTitle)`
  margin: 2rem 0 0;
`;

const zipFieldResponsiveStyles = css`
  ${breakpointsMQ4.xl.down} {
    flex-basis: 30%;
  }
  ${breakpointsMQ4.md.down} {
    flex-basis: 100%;
  }
`;

export const IMZipCodeFieldStyled = styled(IMZipCodeField)`
  ${zipFieldResponsiveStyles}
`;

export const IMZipStateFieldStyled = styled(IMZipStateField)`
  ${zipFieldResponsiveStyles}
`;

export const IMZipCountyFieldStyled = styled(IMZipCountyField)`
  ${zipFieldResponsiveStyles}
`;

export const FormFieldWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// IMSelect uses width: 0 + flex-basis 100% as a row IMForm child. Reset that inside a column wrapper.
export const IMSelectStyled = styled(IMSelect)`
  width: 100%;
  flex: none;
`;

export const AlertStyled = styled(Alert)`
  margin-top: 2rem;
`;
